import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import type { CategoryComboModel } from '../models/category-model';

interface FetchCategoryComboParam {
  occupationalScopeId?: number;
}

interface CategoryHook {
  fetchCategoryComboLoading: boolean;
  fetchCategoryComboError?: Sebrae.HttpErrorModel;
  fetchCategoryCombo(
    param?: FetchCategoryComboParam,
  ): Promise<CategoryComboModel[]>;
}

export function useCategoryService(): CategoryHook {
  const { backendGet } = Sebrae.useBackend();

  const [fetchCategoryComboLoading, setFetchCategoryComboLoading] =
    React.useState(false);
  const [fetchCategoryComboError, setCategoryComboError] =
    React.useState<Sebrae.HttpErrorModel>();
  const fetchCategoryCombo = React.useCallback(
    (param?: FetchCategoryComboParam) => {
      setFetchCategoryComboLoading(true);
      setCategoryComboError(undefined);

      const request = backendGet<CategoryComboModel[]>(
        `/categorias/combo`,
        param?.occupationalScopeId != null
          ? { 'espaco-ocupacional': param.occupationalScopeId }
          : undefined,
      );

      request
        .catch(setCategoryComboError)
        .finally(() => setFetchCategoryComboLoading(false));

      return request;
    },
    [backendGet],
  );

  return {
    fetchCategoryComboLoading,
    fetchCategoryComboError,
    fetchCategoryCombo,
  };
}
